import React from 'react';

import {CreationAttribute} from 'src/modules/event-create/typedefs';

import {Group} from '@pb/kit-component-group';

import {AttributeFormRow} from '../attribute-form/attribite-form-row';

type Props = {
    template: CreationAttribute[],
};

export const AttributeTemplate = ({template}: Props) => {

    if (!template.length) {
        return null;
    }

    return (
        <Group direction="v" gap="xs">
            {template.map(attribute => (
                <AttributeFormRow
                    changeRequestId={null}
                    key={attribute.name}
                    template={attribute}
                    validationHighLight={false}
                />
            ))}
        </Group>
    );
};
